var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/array-slice.js
// module id = 946
// module chunks = 25